// export const myGetter = ( state ) => {
// return state
// }

export const getToken = ( state ) => {
    return state.token
}